<template lang="">
    <v-col cols="12">
        <div class="mb-5">
          <filtros />
        </div>
          <TableS :table="Lista" :type="type" :headerss="header" :loadings="loading"/>
          <transition name="slide2">
             <SingleItemRegister v-show="menu"/>
          </transition>
        <PanelReportes />     
    </v-col>
</template>
<script>
///    <Table :table="Lista.lista" :type="type" :headerss="header" :loadings="loading"/>

import jsPDF from "jspdf";
import Table from "../../../../../dashboard/component/helpers/tools/table";
import TableS from "../../../../../dashboard/component/helpers/tools/tablesearch";
import filtros from "../../../../../dashboard/component/helpers/tools/filter";
import PanelReportes from "../../../../pages/content/subrutas/registros/component/panelReportes";
import SingleItemRegister from './component/SingleRegister';

export default {
  components: {
    Table,
    TableS,
    filtros,
    PanelReportes,
    SingleItemRegister
  },

  data() {
    return {
      // loading:false,
      type: "Registro",
      datos: [],
      header: [
        { text: "Equipo", value: "vm" },
        { text: "Placa / Serial", value: "vp" },
        { text: "Conductor", value: "cn" },
        { text: "Cédula", value: "ci" },
       { text: 'F:H Sincronización', value: 'fecha' },
        {text: 'Locación', value: 'location'},
       { text: "", value: "alerta" }
        // { text: 'F:H Creacion de registro', value: 'fecha' }
      ],
      todos: [
        { title: "todo 1", description: "description 1" },
        { title: "todo 2", description: "description2" },
        { title: "todo 3", description: "description 3" },
        { title: "todo 4", description: "description 4" },
        { title: "todo 5", description: "description 5" }
      ]
    };
  },

  methods: {
    

    

  },

  computed: {
    Lista() {
      return this.$store.state.RegistroLista;
    },

    loading() {
      return this.$store.state.loading_dashboard
    },

    menu(){

      return this.$store.state.menu_registro;

    }
  }
};
</script>